import React from 'react';
import UsageAnalytics from '../../components/analytics/UsageAnalytics';

const AnalyticsPage: React.FC = () => {
  return (
    <div>
      <div className="md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
            Analytics
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Track your API usage, performance metrics, and billing information.
          </p>
        </div>
      </div>

      <div className="mt-8">
        <UsageAnalytics />
      </div>
    </div>
  );
};

export default AnalyticsPage;